import { render, staticRenderFns } from "./mobi-footer.vue?vue&type=template&id=13644922&scoped=true&"
import script from "./mobi-footer.vue?vue&type=script&lang=js&"
export * from "./mobi-footer.vue?vue&type=script&lang=js&"
import style0 from "./mobi-footer.vue?vue&type=style&index=0&id=13644922&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13644922",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VDialog } from 'vuetify/lib/components/VDialog';
installComponents(component, {VCard,VDialog})
